import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { Header, Tabs, Container, PageContent, Alerts, PrivateComponent } from 'components';
import { Margin } from 'styled-components-spacing';
import { globalPropTypes } from 'helpers';
import { useTranslation } from 'react-i18next';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ipma.events',
    url: '/ipma/events',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.ipma.events.ongoing',
    path: '/ipma/events/ongoing',
    key: 'ongoing',
  },
  {
    title: 'navigation.tabs.ipma.events.completed',
    path: '/ipma/events/completed',
    key: 'completed',
  },
  {
    title: 'navigation.tabs.ipma.events.cancelled',
    path: '/ipma/events/cancelled',
    key: 'cancelled',
  },
  {
    title: 'navigation.tabs.ipma.events.duplicated',
    path: '/ipma/events/duplicated',
    key: 'duplicate',
  },
];

const Events = ({ routes, bar, userPermissions }) => {
  const { t } = useTranslation();
  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ipma/events', firstTabPath);

  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={t('page.ipma.events.title')}
        renderActions={({ Button: ButtonRender }) => (
          <PrivateComponent
            permissions={{
              roles: ['ipma_events_create_event'],
            }}
          >
            <ButtonRender secondary as={Link} to="/ipma/event/create">
              {t('page.ipma.events.createButton')}
            </ButtonRender>
          </PrivateComponent>
        )}
      />
      <Tabs items={tabs} />
      {renderExactRedirect()}
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="ipma" />
          </Margin>
          {renderSubRoutes()}
        </Container>
      </PageContent>
    </>
  );
};

Events.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  bar: PropTypes.shape({
    ongoing: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    cancelled: PropTypes.number.isRequired,
    duplicate: PropTypes.number.isRequired,
  }).isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

Events.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ipma, user }) => ({
  bar: ipma.events.bar,
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(Events);
